import styled from "styled-components";

const Align = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default Align;
